if(!customElements.get('fit-buy-dialog')) {
    class FitBuyDialog extends HTMLElement {
        constructor() {
            super();
            this.cartEndpoint = '/cart/add.js';
            this.maxChars = 125;
            this.selectedId = '';
            this.algorithm = false;
            this.fullText = '';
            this.shortText = '';
            this.adultVersionId = null;
            this.youthVersionId = null;
            this.selectedVariantId = null;
            this.productName = null;
            this.productId = null;
            this.collectionId = null;
            // Simple in-memory cache for dialog fragments by handle.
            if(!window.fitBuyDialogCache) {
                window.fitBuyDialogCache = new Map();
            }
            this.productCache = window.fitBuyDialogCache;
        }
        connectedCallback() {
            this.selectors = {
                close: this.querySelector('.heading button.close-dialog'),
                selectedImage: this.querySelector('.selected-product .image'),
                defaultTitle: this.querySelector('.selected-product .product-details .default-title'),
                productTitle: this.querySelector('.selected-product .product-details .product-title'),
                productPrice: this.querySelector('.selected-product .product-details .product-price'),
                productBadge: this.querySelector('.product-badge'),
                collectionProducts: this.querySelector('.collection-products'),
                productDescription: this.querySelector('.product-description'),
                descriptionInline: this.querySelector('.product-description  .inline-text'),
                readMoreLess: this.querySelector('.product-description button'),
                collapsibleContent: this.querySelectorAll('.collapsible-content'),
                continue: this.querySelector('.continue-cta'),               
                stepsbuttons: this.querySelectorAll('.steps button'),
                addToCart: this.querySelector('.continue-cta button'),
                goToProduct: this.querySelector('.continue-cta .go-to-product'),
                goBack: this.querySelector('.heading button.go-back'),
                steps: this.querySelector('.steps'),
                buttonSteps: this.querySelectorAll('.steps button'),
                selectionAlgorithm: this.querySelectorAll('[name="algorithm"]'),
                imageLeftExpansion: this.querySelector('.left-expansion .image')
            }
            this.selectors.selectedImage.innerHTML = '';
            this.selectors.defaultTitle.innerText = '';
            this.selectors.productTitle.innerText = '';
            this.selectors.productPrice.innerHTML = '';
            this.selectors.collectionProducts.innerHTML = '';
            if(this.selectors.close) {
                this.selectors.close.addEventListener('click', () => {
                    this.closeDialog();
                })
            }
            document.addEventListener("fitBuyDialog", (e) => {
                document.body.classList.add('open-buy-dialog');
                this.findProduct(e.detail.productHandle, e.detail.mode);
            });
            if(this.selectors.addToCart) {
                this.selectors.addToCart.disabled = false;
                this.selectors.addToCart.addEventListener('click', event => {
                    if(!this.algorithm) {
                        this.classList.add('select-algorithm');
                        this.algorithm = true;
                        event.target.closest('button').disabled = true;
                    } else {
                        this.addedToCart(event.target.closest('button'));
                    }
                })
            }
            if(this.selectors.goBack) {
                this.selectors.goBack.addEventListener('click', () => {
                    this.classList.remove('select-algorithm');
                    this.algorithm = false;
                    this.selectors.selectionAlgorithm.forEach(input => {
                        input.checked = false;
                    })
                    this.selectors.addToCart.querySelector('.add-to-cart') && (this.selectors.addToCart.querySelector('.add-to-cart').innerText = 'Add To Cart');
                    this.selectors.addToCart.disabled = false;                    
                })
            }
            if (this.selectors.collapsibleContent.length > 0) {
                this.selectors.collapsibleContent.forEach(content => {
                    content.addEventListener('click', event => {
                    const collapsible = event.target.closest('.collapsible-content');
                        if (collapsible) collapsible.classList.toggle('expanded');
                    });
                });
            }
            if(this.selectors.buttonSteps.length > 0) {
                this.selectors.buttonSteps.forEach(btn => {
                    btn.addEventListener('click', event => {
                        if(event.target.classList.contains('final')) {
                            this.selectors.addToCart.disabled = true;
                            this.classList.add('select-algorithm');
                            this.algorithm = true;
                        } else {
                            this.classList.remove('select-algorithm');
                            this.algorithm = false;
                            this.selectors.selectionAlgorithm.forEach(input => {
                                input.checked = false;
                            });
                            this.selectors.addToCart.disabled = false;
                        }
                    })
                })
            }
            this.selectors.readMoreLess.addEventListener('click', event => {
                event.target.closest('.product-description').classList.toggle('read-more');
            })
            if(this.selectors.selectionAlgorithm.length > 0) {
                this.selectors.selectionAlgorithm.forEach(input => {
                    input.checked = false;
                    input.addEventListener('change', event => {
                        this.selectedVariantId = parseInt(event.target.value);
                        this.selectors.addToCart.disabled = false;
                        this.selectors.addToCart.querySelector('.add-to-cart') && (this.selectors.addToCart.querySelector('.add-to-cart').innerText = 'Add To Cart');
                    })
                })
            }
            if(this.selectors.collectionProducts) {
                this.selectors.collectionProducts.addEventListener('click', event => {
                    this.findProduct(event.target.closest('.product').dataset.productHandle, 'none');
                })
            }
        }
        buildCacheEntry(htmlDoc) {
            const image = htmlDoc.getElementById('product-image');
            const productTitle = htmlDoc.getElementById('product-title');
            const productBadge = htmlDoc.getElementById('product-badge');
            const productDescription = htmlDoc.getElementById('product-description');
            const collectionProducts = htmlDoc.getElementById('collection-products');
            const productPrice = htmlDoc.getElementById('product-price');
            const adultVersion = htmlDoc.getElementById('adult-version');
            const youthVersion = htmlDoc.getElementById('youth-version');

            return {
                imageHtml: this.sanitizeImageHtml(image ? image.innerHTML : ''),
                productTitleText: productTitle ? productTitle.innerText : '',
                productBadgeHtml: productBadge ? productBadge.innerHTML : '',
                productDescriptionHtml: productDescription ? productDescription.innerHTML : '',
                collectionProductsHtml: this.sanitizeImageHtml(collectionProducts ? collectionProducts.innerHTML : ''),
                productPriceHtml: productPrice ? productPrice.innerHTML : '',
                adultVersionValue: adultVersion ? adultVersion.value : '',
                youthVersionValue: youthVersion ? youthVersion.value : '',
            };
        }
        getDisplayTitles(rawTitle) {
            const cleanedTitle = (rawTitle || '')
                .replace(/F\.I\.T\./gi, '')
                .replace(/\s+/g, ' ')
                .trim();

            if(/^vector\b/i.test(cleanedTitle)) {
                return {
                    defaultTitle: 'Vector with OFT',
                    productTitle: cleanedTitle.replace(/^vector\b/i, '').trim(),
                };
            }

            const isAllCaps = cleanedTitle.length > 2 && cleanedTitle === cleanedTitle.toUpperCase() && /[A-Z]/.test(cleanedTitle);
            const productTitle = isAllCaps
                ? cleanedTitle.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())
                : cleanedTitle;

            return {
                defaultTitle: '',
                productTitle,
            };
        }
        setDefaultTitle(text) {
            if(!this.selectors.defaultTitle) return;
            const defaultTitle = text || '';
            this.selectors.defaultTitle.textContent = '';
            const parts = defaultTitle.split(/(TM\b)/);

            parts.forEach(part => {
                if(part === 'TM') {
                    const trademark = document.createElement('sup');
                    trademark.className = 'trademark';
                    trademark.textContent = 'TM';
                    this.selectors.defaultTitle.appendChild(trademark);
                    return;
                }
                this.selectors.defaultTitle.appendChild(document.createTextNode(part));
            });
        }
        sanitizeImageHtml(html) {
            if(!html) {
                return '';
            }
            const temp = document.createElement('div');
            temp.innerHTML = html;
            temp.querySelectorAll('img').forEach(img => {
                const existingStyle = img.getAttribute('style') || '';
                const hideStyle = 'color:transparent;font-size:0;line-height:0;text-indent:-9999px;';
                img.setAttribute('style', `${existingStyle}${hideStyle}`);
            });
            return temp.innerHTML;
        }
        applyCachedFragments(cacheEntry) {
            if(this.selectors.selectedImage) {
               this.selectors.selectedImage.innerHTML = cacheEntry.imageHtml || '';
               this.hideAltTextInContainer(this.selectors.selectedImage);
            }
            if(this.selectors.imageLeftExpansion) {
               this.selectors.imageLeftExpansion.innerHTML = cacheEntry.imageHtml || '';
               this.hideAltTextInContainer(this.selectors.imageLeftExpansion);
            }
            const displayTitles = this.getDisplayTitles(cacheEntry.productTitleText);
            this.setDefaultTitle(displayTitles.defaultTitle);
            this.selectors.productTitle.innerText = displayTitles.productTitle;
            if(this.selectors.goToProduct && this.dataset.productHandle) {
                this.selectors.goToProduct.href = `/products/${this.dataset.productHandle}`;
            }
            if(this.selectors.productBadge) {
               this.selectors.productBadge.innerHTML = cacheEntry.productBadgeHtml || '';
            }
            if(this.selectors.productDescription) {
               this.selectors.productDescription.classList.add('active');
               this.selectors.descriptionInline.innerHTML = cacheEntry.productDescriptionHtml || '';
            }
            if(this.selectors.collectionProducts) {
               this.selectors.collectionProducts.classList.add('active');
               this.selectors.collectionProducts.innerHTML = cacheEntry.collectionProductsHtml || '';
               this.hideAltTextInContainer(this.selectors.collectionProducts);
            }
            if(this.selectors.productPrice) {
                this.selectors.productPrice.innerHTML = cacheEntry.productPriceHtml || '';
            }
            if(this.selectors.selectionAlgorithm.length > 0) {
                this.selectors.selectionAlgorithm.forEach(input => {
                    input.checked = false;
                    if(input.id === 'adult-version') {                         
                        input.value = cacheEntry.adultVersionValue || '';
                        input.disabled = cacheEntry.adultVersionValue !== '' ? false : true;
                    } else {
                        input.value = cacheEntry.youthVersionValue || '';
                        input.disabled = cacheEntry.youthVersionValue !== '' ? false : true;                            
                    }
                })
            }
            if (this.selectors.collapsibleContent.length > 0) {
                this.selectors.collapsibleContent.forEach(content => {
                    content.classList.add('active');
                });
            }
            this.selectors.continue.classList.add('active');
            this.selectors.steps.classList.add('active');

            this.selectors.addToCart.disabled = false;
            this.selectors.addToCart.querySelector('.add-to-cart') && (this.selectors.addToCart.querySelector('.add-to-cart').innerText = 'Add To Cart');
        }
        hideAltTextInContainer(container) {
            if(!container) {
                return;
            }
            container.querySelectorAll('img').forEach(img => {
                const existingStyle = img.getAttribute('style') || '';
                const hideStyle = 'color:transparent;font-size:0;line-height:0;text-indent:-9999px;';
                img.setAttribute('style', `${existingStyle}${hideStyle}`);
            });
        }
        async findProduct(productHandle, mode) {
            mode === 'direct' ? this.classList.add('select-algorithm', 'direct') : this.classList.remove('select-algorithm', 'direct');
            mode === 'direct' && (this.algorithm = true);
            if(this.selectors.goToProduct) {
                this.selectors.goToProduct.style.display = mode === 'direct' ? 'none' : '';
            }
            this.dataset.productHandle = productHandle;
            if(this.productCache.has(productHandle)) {
                this.applyCachedFragments(this.productCache.get(productHandle));
                mode === 'direct' && (this.selectors.addToCart.disabled = true);
                return;
            }
            await fetch(`/products/${productHandle}?section_id=fit-buy-dialog-cached`)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(html, 'text/html');
                const cacheEntry = this.buildCacheEntry(htmlDoc);
                this.productCache.set(productHandle, cacheEntry);
                this.applyCachedFragments(cacheEntry);
                mode === 'direct' && (this.selectors.addToCart.disabled = true);
            })
            .catch(error => {
                console.error('Fetch request failed:', error);
            });           
        }
        closeDialog() {
            document.body.classList.remove('open-buy-dialog');
            this.selectors.selectedImage.innerHTML = '';
            this.selectors.imageLeftExpansion.innerHTML = '';
            this.setDefaultTitle('');
            this.selectors.productTitle.innerText = '';
            this.selectors.productPrice.innerHTML = '';
            this.selectors.collectionProducts.innerHTML = '';
            this.selectors.descriptionInline.innerHTML = '';
            this.selectors.collectionProducts.classList.remove('active');
            this.selectors.productDescription.classList.remove('active');
            if (this.selectors.collapsibleContent.length > 0) {
                this.selectors.collapsibleContent.forEach(content => {
                    content.classList.remove('active');
                });
            }
            this.selectors.steps.classList.remove('active');
            this.selectors.continue.classList.remove('active');
            this.classList.remove('select-algorithm');
            this.algorithm = false;
            this.selectors.addToCart.disabled = true;
            this.selectors.addToCart.querySelector('.add-to-cart') && (this.selectors.addToCart.querySelector('.add-to-cart').innerText = 'Add To Cart');
        }
        async addedToCart(target) {
            console.log(this.selectedVariantId);
            target.classList.add('active');
            const data = {
                items: [
                    {
                        id: this.selectedVariantId,
                        quantity: 1
                    }
                ]
            };

            try {
                const response = await fetch(this.cartEndpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(data)
                });

                if (response.ok) {
                    target.classList.remove('active');
                    const cartDrawer = document.querySelector('.Header__Icon[href="/cart"]');
                    cartDrawer && cartDrawer.click();
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: 'buy_dialog_click',
                        event_category: 'Home Page',
                        event_label: this.productName,
                        product_id: this.productId
                    });
                    if(this.selectors.selectionAlgorithm.length > 0) {
                        this.selectors.selectionAlgorithm.forEach(input => {
                            input.checked = false;
                        })
                    }
                    this.closeDialog();
                } else {
                    console.error('Failed to add item to cart:', response.statusText);
                    target.classList.remove('active');
                    target.querySelector('.add-to-cart') && (target.querySelector('.add-to-cart').innerText = 'Out of Stock');
                    target.disabled = true;
                }
            } catch (error) {
                target.classList.remove('active');
                target.querySelector('.add-to-cart') && (target.querySelector('.add-to-cart').innerText = 'Out of Stock');
                target.disabled = true;
                console.error('Error adding item to cart:', error);
            }
        }
    }
    customElements.define('fit-buy-dialog', FitBuyDialog);
}
